// Models
import { AlertDetails } from 'app/modules/alerts/models';
import { ShortCaseResponse } from 'app/modules/cases/responses';

// Types
import { AlertDetailsTab, ShortAlertResponse } from 'app/modules/alerts/types';
import { U21PermissionedTabRouterItem } from 'app/shared/u21-ui/components/dashboard';
import { U21TableColumn, U21TabRouterItem } from 'app/shared/u21-ui/components';
import { ShortAlertResponseFast } from 'app/modules/alerts/types/responses';

// Since AlertDetails/CaseDetails extend their respective Summary
// interfaces, the Investigation type is also equivalent to them
export type Investigation =
  | ShortAlertResponse
  | ShortAlertResponseFast
  | ShortCaseResponse;

export enum InvestigationType {
  ALERT = 'ALERT',
  CASE = 'CASE',
}

export enum InvestigationStatus {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
  IN_REVIEW = 'IN_REVIEW',
}

export enum InvestigationSource {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL',
}

export type CustomAndResultingTabs = [AlertDetailsTab[], U21TabRouterItem[]];

export type InvestigationTableColumn = U21TableColumn<Investigation, any>;

export interface InvestigationTabs extends Omit<
  U21PermissionedTabRouterItem,
  'disabled'
> {
  labelString?: string;
}
export interface AlertFromAlertLocationState {
  alertFromAlert: boolean;
  alertData: Omit<
    AlertDetails,
    'custom_data' | 'alert_subtype' | 'comments' | 'num_alerts' | 'editors'
  >;
  queueId?: number;
}
